import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {BasedataService} from '../shared/basedata.service';
import {UserDefineds, UserDefinedsDelete, UserDefinedsDeleteResult} from './user-defined';
import {ConfigService} from '@docma-mm-core/config/config.service';

const savedProjectUserDefinedsKey: string = 'mm-savedProjectUserDefineds';

@Injectable()
export class UserDefinedApiService extends BasedataService {

  private projectUrl = '/projects/';
  private userDefinedUrl = '/userdefineds';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }


  private getProjectUserDefinedUrl(projectId: number) {
    return super.getFullUrl(this.projectUrl + projectId + this.userDefinedUrl);
  }


  getUserDefineds(projectId: number): Observable<UserDefineds> {
    const endpoint = this.getProjectUserDefinedUrl(projectId);
    return this.http
      .get<UserDefineds>(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }
  updateUserDefineds(projectId: number, userDefindes: UserDefineds): Observable<UserDefineds> {
    const  endpoint = this.getProjectUserDefinedUrl(projectId);
    return this.http
      .put<UserDefineds>(endpoint, userDefindes, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }
  createUserDefineds(projectId: number, userDefindes: UserDefineds): Observable<UserDefineds> {
    const  endpoint = this.getProjectUserDefinedUrl(projectId);
    return this.http
      .post<UserDefineds>(endpoint, userDefindes, { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  deleteUserDefineds(projectId: number, userDefindes: UserDefinedsDelete): Observable<UserDefinedsDeleteResult> {
    const  endpoint = this.getProjectUserDefinedUrl(projectId);
    return this.http
      .delete<UserDefinedsDeleteResult>(endpoint, { body: JSON.stringify(userDefindes), headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
